import React, { useState } from 'react';
import { Container, Row, Col, Form, Alert } from 'react-bootstrap';
import '../styles/ideaSection/ideaSection.min.css';

const ideaIcon = '/images/ideaIcon.svg';

const IdeaSection = () => {
    const [idea, setIdea] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);
        
        const googleSheetsURL = process.env.REACT_APP_GOOGLE_SHEETS_URL;

        if (!googleSheetsURL) {
            setSubmitStatus({ success: false, message: "Erro: Configuração de URL inválida!" });
            setIsSubmitting(false);
            return;
        }

        try {
            const trimmedIdea = idea.trim();
            if (!trimmedIdea) {
                setSubmitStatus({ success: false, message: "Por favor, escreva algo antes de enviar." });
                setIsSubmitting(false);
                return;
            }
            // Using URL parameters instead of POST body for better compatibility
            const response = await fetch(`${googleSheetsURL}?idea=${encodeURIComponent(idea)}`, {
                method: "GET", // Changed to GET for better CORS compatibility
                headers: {
                    "Content-Type": "text/plain", // Simpler content type
                },
            });
            if (!response.ok) throw new Error("Erro ao enviar dados");

            // Even if we can't read the response, we'll assume success
            setSubmitStatus({ 
                success: true, 
                message: "A sua ideia foi enviada com sucesso! Entraremos em contacto em breve." 
            });
            setIdea("");
        } catch (error) {
            console.error("Error:", error);
            setSubmitStatus({ 
                success: false, 
                message: "Falha ao enviar a sua ideia. Tente novamente ou contacte-nos diretamente." 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container fluid className="idea-section py-5 section-separator">
            <Container className='bg-transp'>
                <Row className="justify-content-center text-center bg-transp">
                    <Col md={8} lg={6} className='bg-transp d-flex align-items-start'>
                        <img src={ideaIcon} alt='Ideas Form' className='bg-transp' />
                        <div className='bg-transp text-start ms-4'>
                            <h2 className="fw-bold text-uppercase bg-transp ideas-text fw-bold display-5 ">Tens uma ideia e<br/> queres desenvolvê-la?</h2>
                            <p className="subtext bg-transp ideas-text lead fw-bold">Diz-nos abaixo que Nós ajudamos-te!</p>
                        </div>
                    </Col>
                </Row>

                <Row className="justify-content-center mt-4 bg-transp">
                    <Col md={8} lg={6} className='bg-transp'>
                        {submitStatus && (
                            <Alert variant={submitStatus.success ? "success" : "danger"}>
                                {submitStatus.message}
                            </Alert>
                        )}
                        
                        <Form onSubmit={handleSubmit} className='bg-transp'>
                            <Form.Group className='bg-transp'>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    placeholder="Escreve aqui..."
                                    className="textarea input-container"
                                    value={idea}
                                    onChange={(e) => setIdea(e.target.value)}
                                    required
                                    disabled={isSubmitting}
                                />
                            </Form.Group>
                            <div className='d-flex w-100 justify-content-end bg-transp'>
                                <button 
                                    type="submit" 
                                    className={`mt-3 px-4 main-btn ${isSubmitting ? 'disabled' : ''}`}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Enviando..." : "Enviar"}
                                </button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default IdeaSection;